import { type StaleUpstreamKind, changedUpstreamText } from '@sigora/domain';

/**
 * What the Questions step says of research questions it updated for a change above them, in the
 * plural its noun takes: one module, so the product copy is one file to change. The pending, late,
 * failed and unchanged lines are the shared ones in `reconcile-copy.ts`.
 */

/** What the step's document is called in the shared sentences. */
export const QUESTIONS_DOCUMENT = 'questions';

/** Over updated research questions that changed. */
export const questionsReconciledText = (kinds: readonly StaleUpstreamKind[]): string =>
  `Sigora updated these questions for ${changedUpstreamText(kinds)}. What changed is marked below.`;

/**
 * Over questions waiting on Materials nobody has confirmed since they changed: nothing can update
 * them until then.
 */
export const QUESTIONS_NEED_MATERIALS =
  'Confirm your materials on the Materials step to update these questions.';

/**
 * Over a study with no questions yet whose Materials nobody has confirmed since they changed:
 * nothing can draft them until then.
 */
export const QUESTIONS_DRAFT_NEEDS_MATERIALS =
  'Confirm your materials on the Materials step so Sigora can draft your questions.';
